
export default {
  name: 'FDEmptyData',
  props: {
    text: { type: String, default: '暂无内容' },
    showIcon: { type: Boolean, default: true },
  },
  computed: {
    theme() {
      return this.$route?.query?.theme || this.$store?.state?.theme || 'light'
    },
    imgSrc() {
      try {
        return this.theme === 'dark'
          ? require('@/assets/news/empty-black-block.png')
          : require('@/assets/news/empty-black-white.png')
      } catch (e) {
        return ''
      }
    }
  }
}
